import { styled } from '../../Styles/stitches.config'

export const Indicator = styled('div', {
    bgc: '$primary600',
    h: 1,
    position: 'absolute',
    transition: '$fast',
    zIndex: 1,
})

export const Tab = styled('div', {
    color: '$primary400',
    cursor: 'pointer',
    display: 'grid',
    gap: '$1',
    lineHeight: 1,
    p: '$2',
    placeItems: 'center',
    transition: '$default',

    variants: {
        active: {
            true: {
                color: '$primary600',
            },
        },
        disabled: {
            true: {
                color: '$primary400',
                cursor: 'default',
                pointerEvents: 'none',
            },
        },
    },
})

export const StyledNavigationTabs = styled('nav', {})
